<template lang="pug">
    div
        v-menu(offset-y)
            template(v-slot:activator="{ on }")
                div.moreWrapper(v-on="on")
                    div.icon.mr-2
                        v-icon.moreIcon expand_more
                    div.name {{ activeText }}

            v-list.filterList
                v-list-tile(
                    v-for="(item, index) in items"
                    :key="index"
                    @click="setValue(item)"
                )
                    v-list-tile-title(
                        :class="item.title === activeText ? 'isActive' : ''"
                        v-html="item.title"
                    )
</template>

<script>
    import VueTypes from 'vue-types';

    export default {
        props: {
            name: VueTypes.string.def(''),
            value: VueTypes.any.def(''),
            items: VueTypes.array.def([]),
            callbackFunction: VueTypes.func.def(() => {}),
            filterName: VueTypes.string.def('')
        },
        data() {
            return {
                activeText: ''
            };
        },
        created() {
            if (this.value) {
                this.items.map(item => {
                    if (item.value === this.value) {
                        this.activeText = item.title;
                    }
                });
            }
        },
        methods: {
            /**
             * Set filter value
             * @param {object} item
             */
            setValue(item) {
                this.callbackFunction({
                    value: item.value,
                    name: this.filterName
                });
                this.activeText = item.title;
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_variables.styl";

    .moreWrapper
        display: flex
        align-items: center
        cursor: pointer

    .moreIcon
        background-color: rgba(249, 249, 249, 0.2)
        border-radius: 50%
        font-size: 20px
        color: $theme.white

    .name
        margin-right: 10px
        margin-bottom: 2px

    >>> a
        &.v-list__tile--link
            &:hover,
            & > .isActive
                background: transparent !important
                color: $theme.action
</style>
